<template>
  <div>
    <bd-table-list
      idTable="mandat_ID"
      :breadcrumb="breadcrumb"
      ref="resource"
      title="Mandats"
      subtitle="Recherche de mandats"
      autocomplete_idHistory="warrants"
      autocomplete_field="creancier.nom_soc || mandat.ID"
      bdTable="warehouse_mandat"
      :directLoad="true"
      :actions="actions"
      :fields="fields"
      :Api="Api"
      @row-clicked="selectRow"
      @loaded="refreshRoute"
    >
      <template v-slot:menu>
        <b-row>
          <b-col lg="12">
            <b-button
              v-if="$store.getters.isAdmin"
              variant="secondary"
              :to="{ name: 'addWarrantsPayments' }"
              size="sm"
              icon
              title="Réceptionner des paiements"
              ><b-icon-credit-card-fill></b-icon-credit-card-fill
            ></b-button>
            <!-- <b-button
              v-if="$store.getters.isAdmin"
              size="sm"
              variant="info"
              class="ml-2"
              :href="export_md"
              target="_blank"
              title="Exporter Mise en Demeure"
              ><b-icon-file-earmark-spreadsheet></b-icon-file-earmark-spreadsheet
            ></b-button> -->
            <b-button @click="goToRoutes()" class="ml-2" type="info" size="sm">
              <i class="fad fa-road"></i>
            </b-button>
            <b-button-group class="mr-2 ml-2">
              <b-button
                @click="createRoute"
                v-if="$store.getters.getRoute.length !== 0"
                variant="info"
                size="sm"
                title="Créer un itinéraire"
              >
                <b-icon v-if="!computeRoute" icon="geo-alt-fill"></b-icon>
                <b-icon v-else icon="arrow-clockwise" animation="spin"></b-icon>
                ({{ $store.getters.getRoute.length }})
              </b-button>
              <b-button
                size="sm"
                @click="deleteRoute"
                v-if="$store.getters.getRoute.length > 0"
                variant="danger"
              >
                <b-icon icon="x"></b-icon>
              </b-button>
            </b-button-group>
            
          </b-col>
        </b-row>
      </template>
      <template v-slot:cell(mandat_ID)="data">
        <b-link
          :to="{ name: 'warrantView', params: { id: data.item.mandat_ID } }"
        >
          {{ data.item.mandat_ID }}
        </b-link>
      </template>
      <template v-slot:cell(creancier_nom_soc)="data">
        <b-link
          :to="{ name: 'creditorView', params: { id: data.item.creancier_ID } }"
        >
          {{ data.item.creancier_nom_soc }}
        </b-link>
      </template>
      <template v-slot:cell(debiteur)="data">
        <b-link
          :to="{ name: 'debtorView', params: { id: data.item.debiteurID } }"
        >
          {{ getDebiteur(data.item) }}
        </b-link>
      </template>
      <template v-slot:cell(arrangementID)="data">
        <span
          v-if="
            data.item.isLate == 'Yes' &&
            data.item.mandat_status == 'ouvert' &&
            data.item.arrangementID != 0
          "
        >
          <b-icon icon="exclamation-circle-fill" variant="danger"></b-icon>
        </span>
        <span
          v-else-if="
            data.item.mandat_status == 'ouvert' && data.item.arrangementID != 0
          "
        >
          <b-icon-check-circle-fill
            variant="success"
          ></b-icon-check-circle-fill>
        </span>
        <b-link
          v-if="data.item.arrangementID != 0"
          :to="{ name: 'settlement', params: { id: data.item.arrangementID } }"
        >
          {{ data.item.arrangementID }}
        </b-link>
        <span v-else>N/A</span>
      </template>
    </bd-table-list>
    <b-modal id="warnings" hide-footer>
      <template #modal-title> Attention </template>
      <div v-for="(warning, i) in warnings" :key="i">
        <p v-html="warning"></p>
      </div>
    </b-modal>
    <b-modal size="xl" id="google-route" hide-footer>
      <template #modal-title>Tournée négociateur</template>
      <GoogleRoute :data="googleData"></GoogleRoute>
    </b-modal>
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import GoogleRoute from "@/components/GoogleRoute";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import warrants from "@/services/warrants.js";
export default {
  name: "Warrants",
  components: {
    BdTableList,
    GoogleRoute
  },
  data() {
    return {
      warnings: [],
      Api: warrants,
      urlGoogleMaps: null,
      googleData: {},
      computeRoute: false,
      selectedWarrants: [],

      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Mandats",
          active: true,
        },
      ],
      actions: [
        {
          label: "Éditer",
          to: "warrantEdit",
          icon: "pencil-square",
          variant: "success",
        },
      ],
      fields: [
        {
          key: "mandat_ID",
          label: "#",
          sortable: true,
          class: "text-center",
          thStyle: { width: "100px" },
        },
        {
          key: "mandat_status",
          label: "Statut",
          sortable: true,
          thStyle: { width: "100px" },
        },
        {
          key: "mandat_solde",
          label: "Solde",
          sortable: true,
          class: "text-right",
          formatter: (value) => parseInt(value).toFixed(2) + " €",
          thStyle: { width: "5%" },
        },
        {
          key: "creancier_nom_soc",
          label: "Créancier",
          sortable: true,
          class: "text-truncate",
        },
        {
          key: "debiteur",
          label: "Débiteur",
          sortable: true,
          class: "text-truncate",
          formatter: (value, key, item) => {
            let a = "";
            if (item.debiteur_nom_soc) {
              a += item.debiteur_nom_soc;
            }
            if (item.debiteur_nom && item.debiteur_nom_soc) {
              a += " (" + item.debiteur_prenom + " " + item.debiteur_nom + ")";
            } else if (!item.debiteur_nom_soc) {
              a += item.debiteur_prenom + " " + item.debiteur_nom;
            }
            return a;
          },
        },
        { 
          key: "debiteur_rue1",
          label: "rue",
          sortable: true,
          class: "text-truncate"
        },
        { 
          key: "debiteur_codepostal",
          label: "CP",
          sortable: true,
        },
        { 
          key: "debiteur_localite",
          label: "Localité",
          sortable: true,
        },
     
        {
          key: "mandat_lastnegodate",
          label: "Dern. négo",
          class: "text-center",
          thStyle: { width: "5%" },
          sortable: true,
          formatter: (value) => this.toDate(value),
        },
        {
          key: "mandat_priorite",
          label: "Priorité",
          class: "text-center",
          sortable: true,
          thStyle: { width: "5%" },
        },
        {
          key: "arrangementID",
          label: "Arr.",
          class: "text-center",
          sortable: true,
          thStyle: { width: "5%" },
        },

        {
          key: "negotiateurID",
          label: "Négo",
          class: "text-center",
          sortable: true,
          thStyle: { width: "5%" },
        },
        {
          key: "actions",
          label: "Actions",
          class: "text-center",
          sortable: false,
          thStyle: { width: "100px" },
        },
      ],
    };
  },
  computed: {
    export_md() {
      let url = this.$store.getters.url + "/warrants/md/export?";
      url += "token=" + encodeURIComponent(localStorage.getItem("vue-token"));
      return url;
    },
  },
  methods: {
    goToRoutes() {
      this.$router.push({name: 'routesList', params: { admin: false } })
    },
    getDebiteur(item) {
      let a = "";
      if (item.debiteur_nom_soc) {
        a += item.debiteur_nom_soc;
      }
      if (item.debiteur_nom && item.debiteur_nom_soc) {
        a += " (" + item.debiteur_prenom + " " + item.debiteur_nom + ")";
      } else if (!item.debiteur_nom_soc) {
        a += item.debiteur_prenom + " " + item.debiteur_nom;
      }
      return a;
    },
    deleteRoute() {
      this.$store.commit("deleteRoute");
      this.urlGoogleMaps = "";
      this.refreshRoute();
    },
    refreshRoute() {
      let routes = this.$store.getters.getRoute;
      this.$refs.resource.rows.forEach((el, index) => {
        if (routes.includes(el.mandat_ID)) {
          this.$refs.resource.rows[index]._rowVariant = "success";
        } else {
          this.$refs.resource.rows[index]._rowVariant = null;
        }
      });
      /* let show = false;
      this.$refs.resource.filters.forEach((el) => {
        if (el.showIndex) {
          show = true;
        }
      });
      if (show) {
        this.fields[10].class = "";
      } else {
        this.fields[10].class = "d-none";
      } */
      //this.$refs.resource.render_table();
    },
    selectRow(row) {
      //this.warrants[index]._rowVariant = 'success';
      this.urlGoogleMaps = null;
      const id = row.mandat_ID;
      this.$store.commit("toggleRoute", id);
      this.refreshRoute();

      //this.selectedWarrants = payload;
    },

    accuseDeReception() {
      let filter = [
        {
          nowarehouse: true,
        },
        {
          filterLabel: "En attente d'accusé de réception",
          label: "ouvert ou arrêté",
          sql: "((mandat_status = 'open' OR mandat_status = 'stopped') AND mandat.ackID = 0)",
          value: "open OR stopped",
        },
      ];
      this.$refs.resource.filtering(filter);
    },
    arrangementsNonRespectes() {
      let filter = [
        {
          filterLabel: "Arrangement non respecté",
          label: "Oui",
          sql: "(arrangementID != 0 AND isLate = 'Yes' AND mandat_status = 'open')",
          value: "Oui",
        },
      ];
      this.$refs.resource.filtering(filter);
    },
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    createRoute() {
      this.computeRoute = true;
      this.urlGoogleMaps = null;
      warrants
        .routes({
          nego: this.$store.getters.getKeycloak.me.ID,
          ids: this.$store.getters.getRoute,
        })
        .then((response) => {
          this.computeRoute = false;
          if (response.data && response.data.url) {
            this.urlGoogleMaps = response.data.url;
            this.googleData = response.data;
            this.$bvModal.show("google-route");
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>